import React, { useState } from 'react';
import { Flash } from 'react-ruffle';

const FlashPlayer = ({ width, height, swfTarget }) => {
    const [isOverlayVisible, setOverlayVisible] = useState(true);

    const handleOverlayTouchStart = (e) => {
        if (isOverlayVisible) {
            e.preventDefault(); // Prevents the overlay from blocking scrolling
        }
    };

    const handleOverlayClick = () => {
        // Hide the overlay when the user wants to interact with the Flash content
        setOverlayVisible(false);
    };

    return (
        <div style={{ 
            position: 'relative', 
            width: width, 
            height: height, 
            touchAction: 'auto'  // Allows both scrolling and interaction
        }}>
            <Flash 
                src={`${process.env.PUBLIC_URL || '/karma'}/animate/${swfTarget}`}
                children={<p></p>}
                config={{
                    warnOnUnsupportedContent: false,
                    splashScreen: false,
                    preloader: true,
                    autoplay: "on",
                    wmode: "transparent",
                    unmuteOverlay: "hidden",
                    scale: "SHOW_ALL"
                }}
                style={{ 
                    width: '100%', 
                    height: '100%' 
                }}
            />
            {isOverlayVisible && (
                <div
                    onTouchStart={handleOverlayTouchStart}
                    onClick={handleOverlayClick}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'transparent',
                        zIndex: 10,
                    }}
                />
            )}
        </div>
    );
};

export default FlashPlayer;
